/* eslint-disable ember/no-computed-properties-in-native-classes */
import Schema from '@linc-technologies/linced-common/models/enrolments/schema';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type School from 'linced-app/models/school';

// Proto: enrolments.Schema.
export default class _Schema extends Schema {
  declare [Type]: 'enrolments/schema';

  // Override the stringy attribute with an actual relationship
  @belongsTo('school', { async: true, inverse: null })
  // @ts-expect-error a school relationship replaces the common string id.
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;
}
